import * as React from "react";
const CaretDownIcon = ({
  size = 24,
  title = "CaretDownIcon",
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "pds-icon", title, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.31 9h9.38c1.164 0 1.748 1.35.924 2.14l-4.69 4.493A1.338 1.338 0 0 1 12 16c-.347 0-.68-.132-.925-.367l-4.69-4.494C5.563 10.35 6.146 9 7.31 9Z", fill: "currentColor" }));
export default CaretDownIcon;
